import globals from './globals/sagas';
import feedback from './areas/feedback/sagas';
import cookieConsent from './components/cookie-banner/sagas';
import createAlert from './areas/sidebar/sagas/create-alert';
import removeAlert from './areas/sidebar/sagas/remove-alert';
import removelistItem from './areas/sidebar/sagas/remove-list-item';
import removelist from './areas/sidebar/sagas/remove-list';
import addlistItem from './areas/sidebar/sagas/add-list-item';
import editListSaga from './areas/sidebar/sagas/edit-list';
import reviews from './areas/reviews/sagas';
import logout from './areas/account/sagas/logout';
import orderlists from './areas/sidebar/sagas/order-lists';
import myProductsSaga from './areas/sidebar/sagas/my-products';
import privacySettings from './areas/user/sagas/tracking';
import accountSettings from './areas/account/settings/sagas';

// FIXME: These sagas need the ROUTE_LOADED event to work correctly.
// Since this event is sometimes dispatched any lazily loaded code,
// they need to be here.
import filterSaga from './areas/category/sagas/filter';
import searchSaga from './areas/category/sagas/search';

export default [
  globals,
  feedback,
  cookieConsent,
  createAlert,
  removeAlert,
  removelistItem,
  orderlists,
  removelist,
  addlistItem,
  editListSaga,
  reviews,
  logout,
  filterSaga,
  searchSaga,
  privacySettings,
  myProductsSaga,
  accountSettings,
];
